module.exports = global["Remarkable"] = require("-!./remarkable.min.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?Remarkable!./public/javascripts/mdeditor/remarkable.min.js-exposed
// module id = 20
// module chunks = 0